import { Card, CardContent, CardHeader, Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import LoadingSkeleton from "../general/LoadingSkeleton";
import { JENIS_BAYAR, STATUS_PROGRESS } from "../../helper/Constant";

function DetailProgress({ dataBerkas, dataSantri, pembayarans }) {
    const statusPembayaran = (typePembayaran)=>{
        const pembayaranPendaftaran = pembayarans?.find(p => p.type === typePembayaran);
        return pembayaranPendaftaran?.isLunas ?? false;
    }

    const dataStatus = {
        isUndangan_ujian: false,
        isUjian_seleksi: false,
        isHasil_pengumuman: false,
        isBayar_daftar_ulang: false
    }
    if (!dataBerkas) {
        return (
            <>
                <LoadingSkeleton size={9}></LoadingSkeleton>
            </>
        )
    }
    if(dataSantri){
        const status = dataSantri.status;
        if(status === STATUS_PROGRESS.UNDANGAN_UJIAN){
            dataStatus.isUndangan_ujian = true;
        }else if(status === STATUS_PROGRESS.UJIAN){
            dataStatus.isUndangan_ujian = true;
            dataStatus.isUjian_seleksi = true;
        }else if(status === STATUS_PROGRESS.PENGUMUMAN){
            dataStatus.isUndangan_ujian = true;
            dataStatus.isUjian_seleksi = true;
            dataStatus.isHasil_pengumuman = true;
        }else if(status === STATUS_PROGRESS.BAYAR_DAFTAR_ULANG){
            dataStatus.isUndangan_ujian = true;
            dataStatus.isUjian_seleksi = true;
            dataStatus.isHasil_pengumuman = true;
            dataStatus.isBayar_daftar_ulang = true;
        }
    }
    return (
        <>
            <Card>
                <CardHeader title="Progres Pendaftaran" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell>Langkah</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox checked={dataBerkas.isFormulir ?? false} disabled></Checkbox>
                                    </TableCell>
                                    <TableCell>
                                        Mengisi formulir pendaftaran online
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox checked={statusPembayaran(JENIS_BAYAR.PENDAFTARAN)} disabled></Checkbox>
                                    </TableCell>
                                    <TableCell>
                                        Membayar biaya pendaftaran
                                        <br></br>
                                        <small>Nomor rekening dan nominal yang harus dibayar tercantum pada Surat Informasi. Proses verifikasi memerlukan waktu 10-30 menit setelah pembayaran dilakukan</small>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox checked={(dataBerkas.isSuratKesanggupan && dataBerkas.isAktaKelahiran && dataBerkas.isKartuKeluarga && dataBerkas.isFoto) ?? false} disabled></Checkbox>
                                    </TableCell>
                                    <TableCell>
                                        Mengupload semua berkas yang dibutuhkan
                                        <ul>
                                            <li>
                                                Foto Calon Santri
                                                <br></br>
                                                <small>Putra: background foto warna merah, baju putih berkerah, tanpa atribut, tanpa penutup kepala, tanpa kacamata dan bukan swafoto</small>
                                                <br></br>
                                                <small>Putri: background foto warna merah, hijab putih, tanpa atribut, tanpa kacamata dan bukan swafoto</small>
                                            </li>
                                            <li>
                                                Surat Kesanggupan
                                                <br></br>
                                                <small>Scan surat pernyataan kesanggupan membayar biaya pendidikan dan kebenaran data pendaftaran online yang sudah diisi, dan ditanda tangani di atas materai 10.000</small>
                                            </li>
                                            <li>
                                                Akta Kelahiran
                                            </li>
                                            <li>Kartu Keluarga</li>
                                            <li>
                                                Sertifikasi Bukti Hafalan (Opsional)
                                                <br></br>
                                                <small>Jika santri memiliki hafalan</small>
                                            </li>
                                        </ul>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox checked={dataStatus.isUndangan_ujian ?? false} disabled></Checkbox>
                                    </TableCell>
                                    <TableCell>
                                        Menerima undangan ujian seleksi
                                        <br></br>
                                        <small>Santri bisa mendapat jadwal ujian seleksi setelah semua berkas telah diupload dan transfer biaya pendaftaran diverifikasi oleh sistem</small>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox checked={dataStatus.isUjian_seleksi ?? false} disabled></Checkbox>
                                    </TableCell>
                                    <TableCell>
                                        Mengikuti ujian seleksi
                                        <br></br>
                                        <small>Sesuai alamat/url dan jadwal yang tercantum pada Surat Undangan.</small>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox checked={dataStatus.isHasil_pengumuman ?? false} disabled></Checkbox>
                                    </TableCell>
                                    <TableCell>
                                        Menerima hasil pengumuman ujian seleksi
                                        <br></br>
                                        <small>Akan diumumkan pada jadwal yang telah ditentukan</small>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox checked={statusPembayaran(JENIS_BAYAR.DAFTAR_ULANG)} disabled></Checkbox>
                                    </TableCell>
                                    <TableCell>
                                        Membayar biaya daftar ulang
                                        <br></br>
                                        <small>Nomor rekening dan nominal yang harus dibayar tercantum pada Surat Pengumuman Hasil Selski. Status pembayaran dapat dilihat melalui halaman informasi Santri ini pada bagian Status Pembayaran</small>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>

        </>
    )
}

export default DetailProgress;